import { toast } from "react-toastify";

export async function createCheckoutSession(items, totalPrice) {
  const product = items[0];
  const data = {
    product_name: product.headTitle,
    amount: totalPrice,
  };

  try {
    const response = await fetch(
      "https://motor-easy.clickbooster.io/api/create-checkout-session",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    );

    const result = await response.json();
    console.log("Checkout session response:", result);
    if (result.url) {
      return result.url;
    } else {
      toast.error("Failed to create checkout session.");
      throw new Error("Checkout URL not found in response");
    }
  } catch (error) {
    console.error("Error creating checkout session:", error);
    toast.error("An error occurred while processing your payment.");
    throw error;
  }
}
